import { gql } from '@apollo/client';
import commentFragment from './EventComments/commentFragment';
import regionFragment from './regionFragment';
import sowStatusesFragment from './sowStatusesFragment';
import observationAssignmentsFragment from './observationAssignmentsFragment';
import changeDateRequestFragment from '@shared/fragments/changeDateRequestFragment';
import userEventParticipationInfoCalendarViewFragment from './userEventParticipationInfoCalendarViewFragment';

const eventFieldsFragment = gql`
  fragment EventFields on AppraiserEvent {
    Id
    Type
    Atl {
      ExternalUserId
      Name
      CurrentRole {
        Value
        Title
      }
    }
    AtlObserver {
      ExternalUserId
      Name
      CurrentRole {
        Value
        Title
      }
    }
    Stage
    StartDate
    EndDate
    OrgId
    OrgUnitIds
    Domains
    LogisticalNotes
    DeliveryMethod
    WarningTypes
    EventFlags
    Regions {
      ...RegionFields
    }
    Teams {
      Role
      NumberOfPeople
      Notes
    }
    IntendedStartDate
    IntendedEndDate
    IsAutoCreated
    AtmAssignmentActionRequired
    AtmAssignmentPendingConfirmation
    UserAssignmentPendingActions {
      ObservationAssignmentActionRequired
    }
    TargetUserEventParticipationInfo(targetUserId: null) {
      ...UserEventParticipationInfoFields
    }
    AppraiserEventChangeDateRequest {
      ...ChangeDateRequestFields
    }
    AppraiserEventComments {
      ...CommentFields
    }
    AtlPreferences {
      ExternalUserId
      Rank
    }
    SowStatuses {
      ...SowStatusesFields
    }
    AtmObservationAssignments {
      ...ObservationAssignmentsFields
    }
  }

  ${regionFragment}
  ${changeDateRequestFragment}
  ${commentFragment}
  ${sowStatusesFragment}
  ${observationAssignmentsFragment}
  ${userEventParticipationInfoCalendarViewFragment}
`;

export default eventFieldsFragment;
